// extracted by mini-css-extract-plugin
export default {"tab-wrapper":"f1921f"};